import styled from 'vue3-styled-components';

export const DevelopmentContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    min-height: 60vh;
`;

export const DevelopmentMessage = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 20px;
    padding: 40px;
    background: #ffffff;
    border-radius: 12px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    border: 1px solid #e9ecef;
`;

export const DevelopmentIcon = styled.div`
    font-size: 48px;
    line-height: 1;
`;

export const MessageText = styled.h2`
    font-size: 24px;
    font-weight: 500;
    color: #495057;
    margin: 0;
    text-align: center;
`;